import { useEffect, useState } from "react";
import { Box, Typography, Divider} from "@mui/material";
import "./styles.css";
import logoIcon from "../../../src/assets/vsk_logo.svg";
import ShikshaIcon from "../../../src/assets/vs_shiksha.svg";
import { useTranslationSetup } from "../../utils/useTranslationSetup";

const SplashScreen = ({ setSplash = () => {} }) => {
  const alphabetArray = ["A", "ક", "B", "ખ", "C", "ગ"];
  const [currentIndex, setCurrentIndex] = useState(0);
  const { t } = useTranslationSetup();

  const getStarted = () => {
    setSplash(false);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % alphabetArray.length);
    }, 800);

    return () => clearInterval(intervalId);
  }, []); // Run the effect once when the component mounts
  return (
    <Box className="splash-screen-div">
      <Box className="header-image-container">
        <img src={ShikshaIcon} alt="Header" className="header-image" />
        <img src={logoIcon} alt="Header" className="header-image" />
      </Box>
      <Typography className="heading-text">{t("orf")}</Typography>
      <Box className="container">
        <Box className="ellipse" id="ellipse1"></Box>
        <Box className="ellipse" id="ellipse2"></Box>
        <Box className="ellipse" id="ellipse3">
          <Box className="letter">{alphabetArray[currentIndex]}</Box>
        </Box>
      </Box>
      <Box className="trusted-by-section">
        <Typography className="trusted-by-text">{t("trusted_by")}</Typography>
        <Divider className="trusted-by-divider" />
        <Box className="trusted-by-container">
          <Box className="trusted-by-item">
            <Typography className="trusted-by-number">{t("28_lakh_plus")}</Typography>
            <Typography className="trusted-by-label">{t("students")}</Typography>
          </Box>
          <Box className="trusted-by-item">
            <Typography className="trusted-by-number">{t("1_lakh_plus")}</Typography>
            <Typography className="trusted-by-label">{t("teachers")}</Typography>
          </Box>
          <Box className="trusted-by-item">
            <Typography className="trusted-by-number">{t("29_k_plus")}</Typography>
            <Typography className="trusted-by-label">{t("schools")}</Typography>
          </Box>
        </Box>
      </Box>
      <Box className="get-started-button-box">
      <Box className="get-started-button" onClick={getStarted}>
        {t("get_started")}
      </Box>
      </Box>
    </Box>
  );
};

export default SplashScreen;
